import styled, { keyframes } from 'styled-components';

const dashdraw = keyframes`
  to {
    stroke-dashoffset: 610;
  }
`;

export const AnimatedPath3 = styled.path`
  opacity: 0.3;
  stroke-dasharray: 120 32;
  animation: ${dashdraw} 3.5s linear infinite;
  animation-delay: 0.2s;
  fill: none;
  stroke: #E60000;
  stroke-width: 2;
  stroke-linejoin: round;
  stroke-linecap: round;
`;

export const AnimatedPath2 = styled.path`
  opacity: 0.6;
  stroke-dasharray: 120 32;
  animation: ${dashdraw} 3.5s linear infinite;
  animation-delay: 0.1s;
  fill: none;
  stroke: #E60000;
  stroke-width: 3;
  stroke-linejoin: round;
  stroke-linecap: round;
`;

export const AnimatedPath1 = styled.path`
  stroke-dasharray: 120 32;
  animation: ${dashdraw} 3.5s linear infinite;
  fill: none;
  stroke: #E60000;
  stroke-width: 4;
  stroke-linejoin: round;
  stroke-linecap: round;
`;

export const AnimatedPathCenter = styled.path`
  fill: #E60000;
`;

